// ── Scheduling ────────────────────────────────────────────────────────────
// Paste your Cal.com booking link below after creating your event type.
// It's the part AFTER "cal.com/" — e.g. "skydrobe/strategy-session".
// Leave it as "" until then; the site falls back to the contact form.
export const CALCOM_LINK = "";
